import css from 'styled-jsx/css';
import { colors, typography } from '../../../../config/styles';

export const ConnectTabStyles = css`
  /* Block: Main connect tab component */
  .connect-tab {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  /* Element: Tab headers container - Modern rounded design */
  .connect-tab__headers {
    display: flex;
    background: #f5f5f5;
    border-radius: 12px;
    padding: 4px 12px;
    margin: 24px 0;
    width: 100%;
    height: 40px;
    align-items: center;
    gap: 2px;
  }

  .connect-tab__headers--primary {
    background: #f5f5f5;
    margin-top: 0;
  }

  .connect-tab__headers--rebranding {
    background: #f5f5f5;
    margin-bottom: 28px;

    @mixin mobileToTablet {
      margin-bottom: 38px;
    }
  }

  .connect-tab__headers--secondary {
    background: #f5f5f5;
  }

  /* Element: Individual tab header button - Modern pill design */
  .connect-tab__header {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: ${typography.base};
    font-weight: 500;
    font-family: inherit;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    outline: none;
    border-radius: 12px;
    height: 32px;
    margin: 0;
    background: transparent;
    color: #666;

    @mixin desktop {
      font-size: ${typography.lg1};
    }
  }

  .connect-tab__header:focus {
    outline-offset: 2px;
  }

  .connect-tab__header--primary {
    background: transparent;
    color: #666;
  }

  .connect-tab__header--rebranding {
    background: transparent;
    color: #666;
  }

  .connect-tab__header--secondary {
    background: transparent;
    color: #666;
  }

  /* Element: Header text wrapper */
  .connect-tab__header-text {
    display: block;
    font-weight: 500;
    text-transform: capitalize;
  }

  /* Modifier: Active tab states - Modern white pill */
  .connect-tab__header--active {
    background: ${colors.white.shade1};
    color: #333;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    font-weight: 600;
  }

  .connect-tab__header--active-primary {
    background: ${colors.white.shade1};
    color: #333;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    font-weight: 600;
  }

  .connect-tab__header--active-rebranding {
    background: ${colors.white.shade1};
    color: #333;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    font-weight: 600;
  }

  .connect-tab__header--active-secondary {
    background: ${colors.white.shade1};
    color: #333;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    font-weight: 600;
  }

  /* Element: Tab content panels */
  .connect-tab__content {
    width: 100%;
  }

  /* Element: Tab content panels */
  .connect-tab__content :global(.swatch--container) {
    gap: 8px;
  }

  /* Element: Tab content panels */
  .connect-tab__content :global(li) {
    margin: 0 !important;
  }

  /* Modifier: Hidden tab content */
  .connect-tab__content--hidden {
    visibility: hidden;
    display: none;
  }

  /* Hover states for better UX - Modern subtle effects */
  .connect-tab__header:hover:not(.connect-tab__header--active):not(.connect-tab__header--active-primary):not(
      .connect-tab__header--active-rebranding
    ):not(.connect-tab__header--active-secondary) {
    background: rgba(255, 255, 255, 0.5);
    color: #333;
    transform: scale(1.02);
  }

  /* Active tab hover - subtle enhancement */
  .connect-tab__header--active:hover,
  .connect-tab__header--active-primary:hover,
  .connect-tab__header--active-rebranding:hover,
  .connect-tab__header--active-secondary:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transform: translateY(-1px);
  }

  /* High contrast support */
  @media (prefers-contrast: high) {
    .connect-tab__headers {
      background: #e0e0e0;
      border: 2px solid #333;
    }

    .connect-tab__header {
      border: 1px solid #666;
    }

    .connect-tab__header--active,
    .connect-tab__header--active-primary,
    .connect-tab__header--active-rebranding,
    .connect-tab__header--active-secondary {
      background: #333;
      color: #fff;
      border: 2px solid #000;
    }
  }

  /* Reduced motion support */
  @media (prefers-reduced-motion: reduce) {
    .connect-tab__header {
      transition: none;
    }

    .connect-tab__header:hover {
      transform: none;
    }

    .connect-tab__header--active:hover,
    .connect-tab__header--active-primary:hover,
    .connect-tab__header--active-rebranding:hover,
    .connect-tab__header--active-secondary:hover {
      transform: none;
    }
  }

  /* Touch device optimizations */
  @media (hover: none) and (pointer: coarse) {
    .connect-tab__header:hover {
      background: transparent;
      transform: none;
    }

    .connect-tab__header:active:not(.connect-tab__header--active):not(.connect-tab__header--active-primary):not(
        .connect-tab__header--active-rebranding
      ):not(.connect-tab__header--active-secondary) {
      background: rgba(255, 255, 255, 0.7);
      transform: scale(0.98);
    }
  }
`;
